<div class="flex" [hidden]="isFirstAccess || isChangingPassword">
  <div class="login-content">
    <div class="login-container">
      <ion-button size="small" color="dark" (click)="limparServidor()"
        style="position: absolute; top: 10px; right: 10px; --border-color: #555555; --background: #a1a1a1;">
        limpar
      </ion-button>
      <h2 class="login-title">Bem-vindo!</h2>
      <p class="login-subtitle">InnovaTransit Login</p>
      <form class="login-form" [formGroup]="formGroup" (ngSubmit)="onLogin()">
        <div *ngIf="!empresas.length">
          <ion-item>
            <ion-input label="Usuário" labelPlacement="floating" placeholder="Insira seu usuário"
              formControlName="identificador"></ion-input>
          </ion-item>
        
          <ion-item class="password-item">
            <ion-input [type]="showPassword ? 'text' : 'password'" label="Senha" labelPlacement="floating" placeholder="Senha"
              formControlName="senha">
            </ion-input>
        
            <!-- Ícone de olho -->
            <div class="eye-icon" (click)="togglePassword()">
              <img [src]="showPassword ? 'assets/icon/olho-aberto.png' : 'assets/icon/olho.png'"
                alt="Mostrar ou ocultar senha" />
            </div>
          </ion-item>
        
          <ion-item lines="none" class="remember-me-item" *ngIf="isApp">
            <ion-checkbox slot="start" [(ngModel)]="keepLoggedIn" [ngModelOptions]="{standalone: true}">
            </ion-checkbox>
            <ion-label>Manter conectado neste dispositivo</ion-label>
          </ion-item>
        
          <ion-button expand="full" type="ngSubmit" class="login-button">Entrar</ion-button>
        
          <div class="login-footer">
            <p>
              <!--<a (click)="openRecoverModal()">Esqueceu a senha?</a>-->
            </p>
          </div>
        </div>
        <div *ngIf="empresas.length > 0">
          <p class="ion-text-center">Sua conta está vinculada a mais de uma empresa. Selecione uma para continuar:</p>
        
          <ion-item lines="full">
            <ion-select label="Selecione a Empresa" placeholder="Escolha uma" [(ngModel)]="tenant_id" (ionChange)="onEmpresaChange($event)" name="empresa"
              required>
              <ion-select-option *ngFor="let emp of empresas" [value]="emp.tenant_id">
                {{ emp.label }}
              </ion-select-option>
            </ion-select>
          </ion-item>
        
          <ion-button expand="block" type="submit" color="success" class="ion-margin-top">
            Entrar na Empresa
          </ion-button>
        
          <!-- Botão para voltar se ele quiser mudar o e-mail -->
          <ion-button expand="block" fill="clear" color="medium" (click)="voltarParaCredenciais()">
            Voltar
          </ion-button>
        </div>
      </form>
      <div class="app-version">
        <strong>v1.15.1</strong>
        <ion-button fill="clear" size="small" class="ajuda-botao" (click)="abrirAjuda()">
          <strong>Ajuda</strong>
        </ion-button>
      </div>
    </div>
  </div>
</div>

<div class="flex" [hidden]="!isFirstAccess || isChangingPassword">
  <div class="login-content">
    <div class="login-container">
      <h2 class="login-title">InnovaTransit</h2>
      <p class="login-subtitle">Primeiro Acesso</p>
      <form class="login-form" [formGroup]="primeiroAcessoForm" (ngSubmit)="enviarEmail()">
        <ion-item>
          <ion-input label="Usuário" labelPlacement="floating" placeholder="Email"
            formControlName="identificador"></ion-input>
        </ion-item>
        <ion-button expand="full" type="ngSubmit" class="login-button">Enviar</ion-button>
      </form>
    </div>
  </div>
</div>

<div class="flex" [hidden]="!isChangingPassword">
  <div class="login-content">
    <div class="login-container">
      <h2 class="login-title">InnovaTransit</h2>
      <p class="login-subtitle">Alterar Senha</p>
      <form class="login-form" [formGroup]="alteraSenhaForm" (ngSubmit)="alterarSenha()">
        <ion-item>
          <ion-input label="Nova Senha" labelPlacement="floating" type="password" placeholder="Nova Senha"
            formControlName="senha"></ion-input>
        </ion-item>

        <ion-item>
          <ion-input label="Confirme a Senha" labelPlacement="floating" type="password" placeholder="Confirme a Senha"
            formControlName="confirmaSenha"></ion-input>
        </ion-item>

        <ion-button expand="full" type="ngSubmit" class="login-button">Confirmar</ion-button>
      </form>
    </div>
  </div>
</div>

<!-- BACKDROP ESCURO -->
<div class="modal-backdrop" *ngIf="showRecoverModal"></div>

<!-- MODAL DE RECUPERAÇÃO -->
<div class="recover-modal" *ngIf="showRecoverModal">

  <h3>Recuperar Senha</h3>

  <form [formGroup]="recoverForm">
    <ion-item>
      <ion-input label="Matrícula" labelPlacement="floating" formControlName="matricula"
        placeholder="Digite sua matrícula">
      </ion-input>
    </ion-item>
  </form>

  <!--<div class="modal-buttons">
    <ion-button fill="outline" (click)="closeRecoverModal()">Fechar</ion-button>
    <ion-button (click)="confirmRecover()">Confirmar</ion-button>
  </div>-->

  <div class="modal-buttons">
    <ion-button fill="outline" (click)="closeRecoverModal()" [disabled]="isLoadingRecover">
      Fechar
    </ion-button>

    <ion-button (click)="confirmRecover()" [disabled]="isLoadingRecover">
      <ion-spinner *ngIf="isLoadingRecover" name="crescent"></ion-spinner>
      <span *ngIf="!isLoadingRecover">Confirmar</span>
    </ion-button>
  </div>


</div>

<ion-toast [isOpen]="showToast" position="top" [message]="toastMessage" duration="3000"
  (didDismiss)="showToast = false">
</ion-toast>